module.exports = __webpack_public_path__ + "img/loader.d272ee9c.gif";